import { requestAuthorizationWithParams } from 'eastedu-login-sdk';
import React, { useEffect } from 'react';

const OAUTH_CALLBACK_PATH = '/oauth2/callback';

/**
 * 将第三方平台的登录参数转交给统一登录认证中心。
 */
function redirectToLogin() {
  const searchParams = new URLSearchParams(window.location.search);
  const thirdPartyParams: Record<string, string> = {};

  searchParams.forEach((value, key) => {
    thirdPartyParams[key] = value;
  });

  requestAuthorizationWithParams({
    ...thirdPartyParams,
    return_uri: `${window.location.origin}${OAUTH_CALLBACK_PATH}`,
    clear_session: true,
  });
}

/**
 * 第三方平台登录中转页。
 */
function ThirdPartyLoginRedirect() {
  useEffect(redirectToLogin, []);

  return null;
}

export default ThirdPartyLoginRedirect;
